import React from 'react';
import NumberFormatInfo from './NumberFormatInfo';

const accounting = require('accounting-js');
const _decimalSymbol = ".";
const _digitGroupingSymbol = ",";
const _percentageSymbol = "%";
const _currencySymbol = "";
const _invalidDoubleText = "";
const _emptyText = "";
const _missingValue = "-";
const _emptyValue = "";
const _numberOfDigitsAfterDecimal = "";
const _zero = "0";
class NumberFormatter {

    formatNumber(number, precision) {
        let returnV = accounting.formatNumber(number, {
            precision: precision,
            thousand: ",",
            decimal: "."
        });
        return returnV;
    }

    formatNumberDecimal(number, precision) {
        let returnV = accounting.formatNumber(number, {
            precision: precision,
            thousand: ".",
            decimal: ","
        });
        return returnV;
    }

    formatMoney(number, precision) {
        let returnV = accounting.formatMoney(number, {
            precision: precision,
            thousand: ",",
            decimal: "."
        });
        return returnV.replace("$", "");
    }

    formatNumberToCurrency(number, precision) {
        let returnV = accounting.formatNumberToCurrency(number, {
            precision: precision,
            thousand: ",",
            decimal: "."
        });
        return returnV;
    }

    IsNan(value) {
        if (value == undefined)
            return false;

        if (value.toString().toLocaleUpperCase() == 'NAN')
            return true;

        return false;
    }

    IsError(value) {
        if (value == undefined)
            return false;
        if (value.toString().toLocaleUpperCase() == '#ERROR')
            return true;
        return false;
    }

    DoubleParseNative = (value) => {

        if (value == undefined)
            return 'invalid';

        if (this.IsNan(value))
            return 'invalid';

        if (this.IsError(value))
            return 'invalid';

        return accounting.unformat(value, NumberFormatInfo.DecimalSymbol);
    }

    Double(value, precision) {
        if (value == undefined) {
            return _missingValue;
        }
        if (value == 'missing') {
            return _missingValue;
        }


        if (value == null) {
            return _emptyValue
        }
        if (value == "" && value != 0) {
            return _emptyValue
        }
        if (value == "NaN") {
            return _emptyValue
        }
        
        // Remove the early return for strings, let them be processed through formatting
        // if (typeof value === 'string') {
        //     return value;
        // }
        
        // Parse the value to ensure it's a valid number
        value = this.DoubleParseNative(value);

        if (value == "invalid")
            return NumberFormatInfo.InvalidDoubleText;

        if (precision == undefined)
            precision = NumberFormatInfo.NumberOfDigitsAfterDecimal;


        let doubletext = accounting.formatMoney(value, { symbol: "", precision: precision, thousand: _digitGroupingSymbol, decimal: _decimalSymbol })
        doubletext = doubletext.replace("NaN.undefined", accounting.formatMoney(0.0, { symbol: "", precision: precision, thousand: _digitGroupingSymbol, decimal: _decimalSymbol }));
        return doubletext;
    }

    millionShort(value, precision) {
        if (value == undefined) {
            return _missingValue;
        }
        if (value == 'missing') {
            return _missingValue;
        }
        if (value == null) {
            return _emptyValue
        }
        if (value == "" && value != 0) {
            return _emptyValue
        }
        if (value == "NaN") {
            return _emptyValue
        }
        value = this.DoubleParseNative(value);
        if (value == "invalid")
            return this._InvalidDoubleText;

        if (precision == undefined)
            precision = this._NumberOfDigitsAfterDecimal;

        // Değer string mi diye kontrol et
        let num;
        if (typeof value === 'string') {
            num = parseFloat(value);
        } else {
            num = value;
        }

        const formattedNum = parseFloat(value);
        var numberInMillions = formattedNum / 1000000; // 4563.874
        return numberInMillions;
    }

    doubleNumber(value, precision) {
        if (value == undefined) {
            return _missingValue;
        }
        if (value == 'missing') {
            return _missingValue;
        }
        if (value == null) {
            return _emptyValue
        }
        if (value == "" && value != 0) {
            return _emptyValue
        }
        if (value == "NaN") {
            return _emptyValue
        }
        value = this.DoubleParseNative(value);
        if (value == "invalid")
            return this._InvalidDoubleText;

        if (precision == undefined)
            precision = this._NumberOfDigitsAfterDecimal;

        // Değerin string olup olmadığını kontrol et ve formatla
        let formattedValue;
        formattedValue = this.Double(value, precision);
        formattedValue = parseFloat(formattedValue);
        return formattedValue;
    }

    decimalNumber(value, precision) {
        return accounting.formatNumber(value, {
            precision: precision,  // Ondalık basamak sayısını belirler
            thousand: ",", // Binlik ayırıcı olarak virgül kullanır
            decimal: "."  // Ondalık ayırıcı olarak nokta kullanır
        })
    }

}
export default NumberFormatter;